import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ReactImageGalleryItem } from "react-image-gallery";

import { Props } from "@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhotoPage";
import { strollersPhotoUrl, strollersVariantPhotoUrl } from "@/mk2/apps/strollers/urls";
import { ImageGalleryLoadable } from "@/mk2/components/ImageGalleryLoadable";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { resizeForCover } from "@/mk2/helpers/photos";
import { url } from "@/mk2/helpers/urls";

import styles from "./StrollerProductPhoto.mscss";
import "./StrollerProductPhoto.scss";

export class StrollerProductPhoto extends React.Component<Props> {
    public componentDidMount() {
        const { onCheckHideThumbnails } = this.props;
        if (typeof window !== "undefined") {
            // run on mount if not SSR
            onCheckHideThumbnails();
        }
    }

    public render() {
        const { loadingState, stroller } = this.props;

        return (
            <div className={styles.StrollerProductPhoto}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    hasData={!!stroller}
                />
            </div>
        );
    }

    private renderSuccess = () => {
        const { strollerPhoto, strollerPhotos, hideThumbnails, thumbsKey } = this.props;

        const currentIndex: number = strollerPhotos.findIndex((p) => p.id === strollerPhoto.id);

        const showThumbnails = !hideThumbnails;

        const galleryPhotos: ReactImageGalleryItem[] = strollerPhotos.map((p) => {
            const thumbData = showThumbnails
                ? {
                      thumbnail: p.url250x250,
                      thumbnailHeight: resizeForCover(p, 42).height,
                      thumbnailWidth: resizeForCover(p, 42).width,
                  }
                : {};
            return {
                // id: p.id,
                original: p.url720x720,
                width: p.originalWidth,
                height: p.originalHeight,
                loading: "lazy",
                ...thumbData,
            };
        });

        return (
            <div className={styles.StrollerProductPhoto__gallery}>
                {/* when changing showThumbnails, ImageGalleryLoadable need to be re-rendered */}
                {hideThumbnails !== null ? (
                    <ImageGalleryLoadable
                        key={`gal-thumbs-${thumbsKey}`}
                        items={galleryPhotos}
                        showIndex
                        showThumbnails={showThumbnails}
                        thumbnailPosition={showThumbnails ? "top" : undefined}
                        autoPlay={false}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        slideDuration={500}
                        startIndex={currentIndex}
                        onSlide={this.onSlide}
                        renderLeftNav={this.renderLeftNav}
                        renderRightNav={this.renderRightNav}
                        // renderCustomControls={this.renderCustomControls}
                    />
                ) : (
                    <LoadingPlaceholder width="100%" height={600} />
                )}
            </div>
        );
    };

    private renderLeftNav = (onClick, disabled) => {
        return (
            <div
                key="prev"
                className={styles.StrollerProductPhoto__prev}
                onClick={disabled ? undefined : onClick}
            >
                <FontAwesomeIcon
                    icon={faChevronLeft}
                    className={styles.StrollerProductPhoto__prev__icon}
                />
            </div>
        );
    };

    private renderRightNav = (onClick, disabled) => {
        return (
            <div
                key="next"
                className={styles.StrollerProductPhoto__next}
                onClick={disabled ? undefined : onClick}
            >
                <FontAwesomeIcon
                    icon={faChevronRight}
                    className={styles.StrollerProductPhoto__next__icon}
                />
            </div>
        );
    };

    // private renderCustomControls = () => {
    //     const { photoId, strollerPhotos } = this.props;
    //     const image = strollerPhotos.find((p) => p.id === photoId);
    //     const showMagnifier = Boolean(image.fullSizeUrl);
    //     const showControls = showMagnifier;
    //
    //     if (!showControls) {
    //         return null;
    //     }
    //
    //     return (
    //         <div className={styles.StrollerProductPhoto__controls}>
    //             {showMagnifier && (
    //                 <a
    //                     data-google-interstitial="false"
    //                     key="magnifier"
    //                     href={image.fullSizeUrl}
    //                     target="_blank"
    //                     rel="noopener"
    //                     className={styles.StrollerProductPhoto__controls__control}
    //                 >
    //                     <FontAwesomeIcon icon={faSearchPlus} />
    //                 </a>
    //             )}
    //         </div>
    //     );
    // };

    private onSlide = (currentIndex: number) => {
        const {
            routeNavigate,
            strollerPhotos,
            strollerVariantId,
            routeParams: { slug },
        } = this.props;
        const image = strollerPhotos[currentIndex];
        const gotoUrl = strollerVariantId
            ? url(strollersVariantPhotoUrl, {
                  slug,
                  variantId: strollerVariantId,
                  photoId: image.id,
              })
            : url(strollersPhotoUrl, {
                  slug,
                  photoId: image.id,
              });
        routeNavigate(gotoUrl, { replace: true });
    };

    private load = () => {
        const { strollerSlug, strollerVariantId, photoId, onLoad } = this.props;
        onLoad(strollerSlug, strollerVariantId, photoId);
    };
}
